module.exports = __webpack_public_path__ + "img/battery-three-quarters.376d3d71.svg";